import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo3.webp";
import voicePhotoB from "/public/voice-photo3b.webp";

export default function CareerArticle3(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.3 堅い印象のあった業界へ未経験でのチャレンジ"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.3 堅い印象のあった業界へ未経験でのチャレンジ。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/3"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no3 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.3",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="堅い印象のあった業界へ未経験でのチャレンジ"
                  avatar="Y.Nさん - 2016年入社"
                />
                <figure className="relative mt-6 block aspect-2/1 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="堅い印象のあった業界へ未経験でのチャレンジ Y.Nさん - 2016年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>── Y.Nさんが入社されたのは?</Interviewer>
                <Interviewee>
                  2016年に入社しました。出身が田舎なので都会に出たい！と思い上京し、前職はプラント系の設計等していました。転職組です。
                </Interviewee>
                <Interviewer>
                  なるほど。それではシステム業界は未経験での入社なんですね。
                </Interviewer>
                <Interviewee>
                  そうなんです。システムの業界は未経験でした。
                </Interviewee>
                <Interviewer>
                  ToccaSystemsに入った時の印象を教えてください。
                </Interviewer>
                <Interviewee>
                  この業界って堅いイメージありませんか？私は堅いイメージを持って転職したのですが、入社したら、社内で気兼ねなく会話ができて、イメージが崩れました（笑）取締役達の年齢が比較的近いということや、今もエンジニアとして動いているからかもしれないですね。
                </Interviewee>
                <div className="relative aspect-1.91/1">
                  <Image
                    src={voicePhotoB}
                    alt="【Voices: メンバーの声 No.3】 インタビューカット"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  ToccaSystemsの好きなところはどこですか？
                </Interviewer>
                <Interviewee>
                  他の方も同じ意見を言ってるかもしれませんが、コミュニケーションがとても取りやすいところです。
                </Interviewee>
                <Interviewer>
                  仕事で思い通りにいかないことはありますか？
                </Interviewer>
                <Interviewee>
                  プロジェクトをチームで進行する際は、想定通りに行かない時もあります。そういう事態にならないようしていますが（笑）でも、その際はリカバリー法を考えて、自分のアイデアを共有するようにしています。
                </Interviewee>
                <Interviewer>
                  業務において、自分の強みは何だと思いますか？
                </Interviewer>
                <Interviewee>
                  オールマイティーに働けるところだと思います。
                </Interviewee>
                <Interviewer>
                  今、勉強していることがあれば教えてください。
                </Interviewer>
                <Interviewee>
                  プロジェクトが進行する中で、常に技術を学ぶ努力をしています。新しい技術が必要な時って多いんですよ。そういう時は朝早く出社して、業務を兼ねて勉強しています。朝は電話も鳴らないし、人もいなくて、静かで勉強が捗るんです。たまにですけど…（笑）
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
